var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMkMonogramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.76 333.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final_MK_Monogram",
    "data-name": "Final MK Monogram"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.6,236.37c10.48-21.55,16.36-45.74,16.36-71.31C348.96,74.87,275.85,1.76,185.67,1.76c-34.59,0-66.66,10.76-93.07,29.11"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M334.9,98.76s-2.24-13.21,1.93-20.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.76,66.91s3.57,17.31-6.61,19.7c-5.31,1.01-3.74-13.67,6.61-19.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.58,55.55s-1.33,10.37-.71,19.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M324.98,36.85s5.04,6.43,4.31,18.25c-.88,10.88-6.38,11.46-7.53,11.54s-6.59-3.49-4.53-13.87c2.06-10.38,7.75-15.92,7.75-15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320.61,73.01s-8.22-3.76-19.06-2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M312.42,70.82s-1.97-5.78-15.54-5.9c-9.55.12-14.45,4.78-14.45,4.78,0,0,9.77,8.54,20.44,7.53,10.71-1.01,9.55-6.41,9.55-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.6,59.79s-3.13-10.9-1.73-16.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.83,51.21s4.72-.94,4.25-9.47c-.07-7.58-2.81-9.08-2.81-9.08,0,0-4.82,5.31-4.95,12.1-.13,6.78,3.52,6.46,3.52,6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.61,53.15s-3.66-1.25-8.63-1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M299.39,51.87s-1.7-4.54-8.52-1.24c0,0,4.74,4.75,8.52,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.13,45.66s.46-11.38,3.53-16.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.1,37.19s12.05-1.39,7.94-21.4c0,0-16.61,13.48-7.94,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.49,39.03c2.5-.21,4.95,0,7,.34,3.07.5,5.21,1.26,5.21,1.26,0,0-9.7-11.77-13.33-21.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.49,39.36s.28,4.02-7.46,3.53c-7.74-.49-11.29-4.45-11.29-4.45,0,0,14.62-7.72,18.75.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M283.41,28.87s4.84-6.95-.21-16.51-10.54-11.68-10.54-11.68c0,0-2.7,11.7.25,19.69,2.94,7.99,8.73,9.66,10.5,8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M280.5,32.16s-7.36-4.94-22.91-6.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.46,27.57s2.14-5.35-12.26-7.65c-7.89-1.21-17.67,4.67-17.67,4.67,0,0,9.65,7.68,18.55,7.86,8.9.18,11.38-4.88,11.38-4.88Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 321.97,
    cy: 90.63,
    r: 4.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 316.41,
    cy: 80.24,
    r: 2.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 331.55,
    cy: 67.92,
    r: 2.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 301.65,
    cy: 59.76,
    r: 2.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 309.27,
    cy: 89.02,
    r: 2.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 329.56,
    cy: 100.55,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 340.1,
    cy: 94.56,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 313.22,
    cy: 56.21,
    r: 1.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 290.66,
    cy: 45.96,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 283.71,
    cy: 51.58,
    r: 1.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 267.92,
    cy: 48.47,
    r: 2.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 289.91,
    cy: 30.04,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 293.41,
    cy: 16.01,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 265.78,
    cy: 34.73,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 264.96,
    cy: 15.67,
    r: 1.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 258.39,
    cy: 15.75,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 257.31,
    cy: 6.7,
    r: 1.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 241.28,
    cy: 17.53,
    r: 1.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 248.37,
    cy: 10.81,
    r: 1.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 239.63,
    cy: 6.98,
    r: 1.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.52,327.93c-18.28,2.5-65.78,5.11-111.79-24.54-13.73-8.85-26.04-19.73-36.58-32.34-11.79-14.1-21.43-30.49-27.9-47.41l1.21-.46c6.41,16.79,15.98,33.05,27.68,47.04,10.47,12.52,22.68,23.31,36.29,32.09,45.66,29.43,92.78,26.83,110.92,24.35l.18,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.36,307.5c-17.98,2.48-25.26-5.55-25.61-5.96l-.53-.61.72-.38c20.67-10.95,36.56,3.17,36.72,3.31l.83.75-1.07.34c-4.06,1.28-7.74,2.1-11.05,2.55ZM64.33,301.28c2.47,2.13,12.56,9.07,33.53,2.8-3.52-2.66-16.82-11.16-33.53-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.2,280.98l-1.06-.73c.07-.1,6.99-10.21,12.65-17.18l1,.81c-5.62,6.93-12.52,16.99-12.59,17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.71,304.87c-.17-.03-17.18-3.31-34.37-2.95l-.03-1.29c17.33-.36,34.47,2.94,34.64,2.98l-.25,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.37,304.68s-.07-.08-.15-.17c-7.47-8.52-7.74-18.56-7.75-18.99l1.29-.02c0,.08.17,6.24,3.73,12.83-.32-2.08-.19-4.6.93-7.46l1.2.47c-2.72,6.94,1.04,11.71,1.61,12.38.03.03.06.06.08.09l-.95.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.64,292.54c-14.08,1.94-28.23-11.91-28.84-12.51l.89-.93c2.5,2.31,15.12,3.54,24.33,4.44,4.25.41,7.92.77,10.16,1.17,3.94.7,7.25,1.87,9.33,2.74.5.21.97.38,1.39.53.64.13,1.35.34,2.21.64l-.35,1.24s-.92-.19-2.24-.65c-1.54-.29-2.62.01-5.12.7-2.16.6-5.44,1.5-10.91,2.5-.28.05-.56.1-.85.14ZM33.89,281.88c5.09,4.09,15.49,11.07,25.37,9.26,5.42-1,8.66-1.89,10.8-2.48.96-.26,1.73-.48,2.43-.62-1.96-.73-4.56-1.53-7.53-2.06-2.19-.39-5.84-.74-10.06-1.15-8.9-.86-16.43-1.68-21.01-2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.99,288.68c-.07-.08-7.28-7.98-22.95-10.43-12.64-1.98-19.47.44-21.65,1.46l2.82,2.45-.85.97-4.17-3.62.71-.47c.28-.19,7.16-4.59,23.34-2.06,16.16,2.52,23.42,10.51,23.72,10.85l-.96.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.17,286.11c-.03-.08-.83-2.11-1.66-5.25-.63-2.38-1.1-4.75-1.4-7.03-.52-3.92,1.25-8.07,2.98-11.22-.88-.38-1.64-.94-2.26-1.66-1.33-1.56-2.18-4.1-2.11-6.32l.03-1.35c.03-1.55.06-3.15.26-4.73.19-1.5.43-3.37,2.03-4.7,1.16-.97,3.13-1.8,4.91-1.48,1.09.2,1.95.81,2.5,1.76.34.64.61,1.29.8,1.94,4.41-2.35,7.05-1.44,8.49-.24,2.62,2.18,2.97,6.55,2.21,8.74-1.33,3.83-6.52,9.55-14.79,8.58-.28-.03-.56-.08-.83-.14-1.68,3.02-3.44,7-2.96,10.64.3,2.23.76,4.54,1.37,6.87.81,3.07,1.6,5.09,1.61,5.11l-1.2.47ZM75.02,261.83c.1.02.2.03.3.04,7.53.88,12.23-4.27,13.42-7.72.64-1.84.24-5.6-1.82-7.32-1.67-1.4-4.22-1.2-7.36.55.77,4.51-1.39,8.82-2.43,10.88l-.13.26c-.22.45-.59,1.04-1.05,1.79-.28.45-.6.97-.93,1.53ZM74.59,243.63c-1.04.14-2.07.66-2.73,1.21-1.13.94-1.36,2.19-1.58,3.87-.19,1.51-.22,3.08-.25,4.59l-.03,1.36c-.05,1.92.67,4.11,1.8,5.44.51.6,1.16,1.06,1.92,1.37.4-.69.78-1.31,1.12-1.85.43-.69.8-1.29.99-1.69l.13-.26c1.2-2.38,4-7.96,1.34-12.92-.35-.61-.89-.99-1.6-1.12-.37-.07-.75-.06-1.13-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.28,281.47l-.22-.65c-.14-.42-3.3-10.42,12.96-17.93l.84-.39.07.93c0,.12.78,12.2-13.02,17.78l-.63.26ZM84.65,264.5c-12.02,5.89-11.9,13-11.53,15.23,10.17-4.44,11.41-12.44,11.53-15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.26,286c-2.3.32-4.43-1.3-4.74-3.59s1.3-4.43,3.59-4.74,4.43,1.29,4.74,3.59c.32,2.3-1.29,4.43-3.59,4.74ZM91.29,278.95c-1.59.22-2.71,1.69-2.49,3.29s1.7,2.71,3.29,2.49,2.71-1.7,2.49-3.29-1.7-2.71-3.29-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.43,291.58c-1.33.18-2.55-.75-2.74-2.07s.75-2.55,2.07-2.73,2.55.75,2.73,2.07c.18,1.33-.75,2.55-2.07,2.74ZM97.94,288.05c-.62.09-1.06.66-.97,1.28s.66,1.06,1.28.97,1.06-.66.97-1.28-.66-1.06-1.28-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.63,275.09l-3.96-4.61c-3.75-4.36-12.13-6.43-12.21-6.45l.3-1.26c.3.07,6.18,1.52,10.47,4.67-2.03-4.93-5.07-15.11.09-23.15l1.09.69c-6.5,10.15,1.24,24.61,1.32,24.76l2.91,5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.45,266.69c-2.03.28-3.9-1.14-4.18-3.17s1.14-3.9,3.17-4.18,3.9,1.14,4.18,3.17-1.14,3.9-3.17,4.18ZM43.61,260.61c-1.32.18-2.25,1.41-2.07,2.73s1.41,2.25,2.73,2.07c1.32-.18,2.25-1.41,2.07-2.73s-1.41-2.25-2.73-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.06,245.39c-2.23.31-4.3-1.26-4.61-3.49-.31-2.23,1.26-4.3,3.49-4.61s4.3,1.26,4.61,3.49c.31,2.23-1.26,4.3-3.49,4.61ZM59.12,238.57c-1.53.21-2.6,1.62-2.39,3.15s1.62,2.6,3.15,2.39,2.6-1.62,2.39-3.15-1.62-2.6-3.15-2.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.66 255.52 38.38 248.43 1.46 224.71 2.16 223.62 39.12 247.38 48.45 254.5 47.66 255.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,249.31l-.9-.06c-.46-.03-11.47-.76-20.1-4.67-7.27-3.3-13.66-12.82-17.09-17.94-.7-1.04-1.24-1.86-1.62-2.34l-.83-1.08,1.36.04c.32,0,32.38,1.23,38.94,25.18l.24.87ZM2.65,224.64c.26.38.55.81.87,1.28,3.12,4.65,9.61,14.34,16.55,17.48,7.01,3.18,15.88,4.22,18.73,4.48-6.03-19.5-30.18-22.75-36.14-23.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.88,226.24l-.91-.89s-4.84-4.78-9.4-11.65c-4.78-7.21-6.39-25.67-1.39-36.13l.28-.58.58.28c.69.33,16.72,8.53,11.02,47.72l-.18,1.26ZM22.05,178.77c-4.47,10.21-2.9,27.41,1.6,34.21,3.3,4.99,6.73,8.82,8.32,10.51,4.45-32.9-7.17-42.86-9.92-44.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.17,225.99c-1.73-4.25-3.14-8.6-4.18-12.92-1.1-4.58-1.55-8.06-2.02-11.75-.47-3.66-.95-7.45-2.12-12.71-.73-3.3-1.6-6.6-2.59-9.79l1.23-.38c1,3.23,1.88,6.56,2.62,9.9,1.18,5.32,1.67,9.14,2.14,12.83.47,3.65.91,7.1,1.99,11.61,1.02,4.26,2.41,8.55,4.12,12.74l-1.19.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.11,249.91c-.14-.45-3.45-11.07-2.39-17.45,1.06-6.33,5.01-13.53,5.18-13.83l1.13.63c-.04.07-4.01,7.3-5.03,13.42-1.01,6.07,2.31,16.75,2.34,16.85l-1.23.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.61,220.83l-.1-1.25c-.29-3.65-.11-10.84,4.44-17.99,4.09-6.43,9.76-9.64,12.77-10.98l1.01-.45-.11,1.1c-.05.48-1.18,11.79-4.92,16.73-3.67,4.85-11.78,11.73-12.13,12.02l-.96.81ZM63.2,192.28c-3.02,1.5-7.69,4.53-11.17,10-3.85,6.06-4.43,12.16-4.31,15.9,2.31-2.02,8.1-7.21,10.94-10.96,2.86-3.77,4.14-11.93,4.53-14.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.22,220.81l-1.2-.47c1.57-3.98,3.47-7.75,5.64-11.21,1.11-1.78,2.12-3.18,3.18-4.67,1.21-1.69,2.58-3.61,4.4-6.48,1.35-2.12,2.65-4.28,3.87-6.44l1.12.63c-1.23,2.18-2.54,4.36-3.9,6.5-1.84,2.9-3.22,4.83-4.44,6.53-1.1,1.54-2.05,2.86-3.14,4.61-2.13,3.39-3.99,7.09-5.53,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.85,237.39l-1.23-.38c.05-.18,1.4-4.46,7.16-8.71,2.76-2.04,7.51-4.42,12.11-6.72,4.52-2.26,9.19-4.6,10.12-5.81l1.03.78c-1.11,1.45-5.49,3.65-10.57,6.18-4.55,2.27-9.25,4.62-11.91,6.6-5.38,3.98-6.68,8.01-6.69,8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.8,231.22c-.47.07-.77.1-.83.11l-1.07.12.4-1c6.63-16.52,25.41-15.53,25.6-15.52l.97.06-.43.87c-.14.28-3.44,6.79-9.3,10.55-4.94,3.16-12.77,4.46-15.34,4.81ZM67.26,216.49c-5.58.77-14.84,3.56-19.32,13.41,2.76-.41,10.02-1.7,14.5-4.57,4.3-2.75,7.21-7.2,8.33-9.12-.81.01-2.03.08-3.51.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.2,323.08c-.04-.09-.12-.19-.23-.19-.09,0-.17.06-.24.12-3.79,3.33-7.82,6.36-12.69,7.9-14.8,4.65-23.76-8.31-29.7-19.72-5.72-10.99-11.09-22.16-16.15-33.47-4.39-9.82-8.6-19.87-15-28.6-4.12-5.61-9.11-10.84-15.44-13.93-4.08-1.99-8.4-2.72-12.85-3.31-8.3-1.1-18,3.37-18,3.37,0,0,24.34-24.42,35.38-35.38s16.28-15.19,21.14-17.69c1.32-.68,2.7-1.22,4.13-1.63,1.71-.48,3.44-.76,5.21-.85.04,0,.08,0,.1-.03.03-.03.03-.07.03-.11v-.74c0-.06,0-.12-.02-.16-.05-.08-.17-.09-.26-.08-1.25.04-2.5.05-3.76.05h-28.12c-.97,0-1.94,0-2.9,0-.03,0-.06,0-.08.02-.03.02-.04.06-.05.09-.07.29-.06.6.01.89.07.25.87.15,1.09.16.43.02.85.05,1.28.09.82.08,1.64.21,2.44.4,1.96.48,4.27,1.28,5.49,3,1.88,2.66-.63,9.31-7.28,15.97-5.95,5.95-31.44,31.4-36.78,36.73v-6.01c-1.99,1.19-6.83,3.91-14,3.39v17.43c-.78.75-1.57,1.49-2.34,2.25-7.39,7.4-16.69,14.54-18.39,25.64-.07.39-.12.77-.16,1.16-.13,1.29-.11,2.61.07,3.9.17,1.28.5,2.55,1.01,3.74.23.53,2.2,5.74,7.68,6.16.26.01,41.97-.01,42.14-.01v-1.16s-6.08.76-10.99-1.67c-4.91-2.43-5-12.26-5-14.43,0-.03,0-.05.01-.07,0-.21-.02-.41-.02-.61v-37.39c6.76-3.75,12.23-4.72,16.71-4.77,8.08-.1,13.13,4.21,17.98,11.09,4.37,6.2,7.53,13.21,10.36,20.22,5.58,13.82,9.36,28.54,16.89,41.51,5.49,9.46,13.17,17.97,23.08,22.59,5.21,2.43,11.16,3.83,16.9,4.09,4.36.2,8.83-.46,12.71-2.45,3.02-1.55,6.07-3.91,8.36-6.43.26-.28.44-.7.28-1.05ZM244.93,275.68c0,.31-.02.61-.03.91,0,.04.01.07.01.1,0,3.47-.4,12-5.44,14.56-3.21,1.63-7.54,1.94-10.16-.93-.31-.34-.62-.69-.92-1.04-.23-.27-.42-.6-.61-.91-.45-.76-.81-1.59-1.07-2.43-.27-.86-.44-1.76-.54-2.66-.1-.9-.12-1.82-.07-2.72.03-.53.08-1.05.16-1.57,1.52-10.46,10.56-17.46,17.58-24.66l1.09-1.08v22.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.57,182.42c1.45,1.28,2.37,3.04,2.98,4.85.81,2.37,1.13,4.87,1.29,7.37.01.15.02.3.03.45.03.5.05.99.06,1.49v26.27c2.79.12,8.79-.13,14-3.78v-22.49c0-.27.02-.53.03-.8,0-.05-.01-.09-.01-.15,0-6.16,1.67-11.74,5.46-13.93,3.36-1.94,9.9-1.73,11.33-1.66-.02-.47-.03-.94-.02-1.41h-38.64c-.23.54-.48,1.1-.76,1.68,1.57.4,3.06,1.06,4.26,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.45,231.47c-3.61.31-3.81,3.06-3.92,4.11-.11,1.06.14,5.22-4.25,8.67-4.39,3.44-18.92,9.07-36.14,4.57s-21.36-16.67-22.51-21.44c0,0,18.69-1.2,43.54-14.75,4.84,4.37,10.69,8.5,17.93,11.76,4.83,2.18,21.78,10.35,40.28,2.33,3.58-1.51,9.86-4.32,14.06-11.12,3.97-6.45,3.59-12.61,3.59-12.61,0-2.62.02-5.3-1.96-8.32s-5.58-2.67-6.44-.38-.26,4.89,2.24,6.56c.29.19.88.82,1.22,1.3,2.6,3.71,5.63,13.65-11.88,21.79-30.67,11.67-53.67-14.33-53.67-14.33,41.56-26,35-45.22,27.56-49.78-19.22-8.78-49.44,15.33-49.44,15.33-7.56-16.33-9.78-40.11-9.78-40.11.45-.14.89-.3,1.33-.46,2.18-.79,4.32-1.69,6.43-2.64,3.52-1.59,6.96-3.36,10.31-5.29,4.35-2.5,8.55-5.26,12.57-8.28,8.44-6.35,17.16-14.02,21.69-23.76,3.98-8.56,4.32-20.13-2.04-27.68-1.86-2.21-4.21-3.95-6.8-5.2-1.97-.95-4.08-1.63-6.22-2.05-.89-.17-1.8-.31-2.71-.36-3.8-.21-8.66.07-13.78,2.02-23.99,9.12-28.93,45.44-29.78,51.7-1.1,8.06-.89,15.15-.61,19.96-.76.32-3.31,1.43-7.04,3.22.4,1.35,1.22,3.78,2.31,5.3,1.73-.8,3.47-1.58,5.21-2.32,0,0,0-.09,0-.09,1.15,11.65,3.64,20.29,4.69,23.7,2.16,7,4.76,13.08,7.24,18.04-2.15,2.02-9.93,9.67-15.33,19.29-2.3,4.1-4.38,8.4-5.47,12.79-.79,3.16-1.3,6.12-1.42,8.96-.06,1.52.13,3.15.14,4.42-7.95.72-13.27-.24-14.09-.37-9.1-1.5-17.79-5.77-23.01-13.61-7.44-11.16-6.22-25.21-.03-36.7,4.65-8.64,11.84-15.7,19.83-21.4,3.21-2.29,6.57-4.4,10.01-6.39,3.97,2.31,8.26,3.25,12.85,3.65.81.07,1.61.11,2.42.09.42-.01.83-.04,1.25-.09.21-.02.42-.05.63-.08.06,0,.36-.05.44-.13,0-.08-.01-.14-.01-.24-.09-.06-.34-.19-.41-.24-2.46-1.46-4.81-3.16-6.8-5.2-1-1.03-1.91-2.14-2.65-3.36-.8-1.31-1.29-2.78-1.73-4.24-1.43-4.72-1.35-9.49-1.35-14.35V51.03s.76-12.64,14.46-13.39l-.03-1.02h-27.9l-34.68,73.82L61.44,36.62h-29.51v1.65s17,1.02,17,6.43v79.62s-3.41,24.76-23.89,25.43l-.06.86h48.95v-1.04s-19.42.15-23.01-25.59l-.3-76.46,43.92,80.03,41.38-89.11v84.71c0,7.06-.8,15,4.23,20.65.08.09.16.17.24.26-.03-.03-.06-.05-.08-.08-3.38,1.91-6.88,3.98-10.51,6.3-16.89,10.78-30.5,28.42-26.83,49.64,0,0,3.83,32.61,49.89,27.72,0,0,2.83,21.22,32.28,23.83,18.39,1.56,31.44-5.89,36.56-10.17s3.36-10.17-.25-9.86ZM171.28,122.88c.06-7.5.69-15.06,3.21-25.32,4.92-19.83,17.83-37.08,33.83-36.21,16,.87,24.75,21.63,7.17,40.71s-44.33,27.08-44.33,27.08c0,0,0-2.12.12-6.26ZM213.02,162.15c5.5-2.08,23.92-5.75,21.42,11.75-1.49,7.65-5.86,13.28-11.57,19.49-9.11,9.14-20.21,15.38-20.21,15.38-3.76-4.06-7.37-8.29-10.25-12.75-5.63-8.72-9.06-16.61-9.06-16.61,14.83-11.17,24.17-15.17,29.67-17.25ZM157.2,212.08c2.77-7.35,8.45-16.71,19.58-27.16,2.96,5.4,5.45,8.93,6.32,10.13,3.59,5.01,8.04,11.02,14.13,16.71-5.15,2.75-25.68,13.19-42.59,14.4,0,0-.59-5.69,2.57-14.08Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkMonogramWhite);
export default __webpack_public_path__ + "static/media/MKMonogramWhite.ac161b6528032b7f4e0edec470d75705.svg";
export { ForwardRef as ReactComponent };